
import { useSelector, useDispatch } from 'react-redux';

import TopMenu from '../TopMenu/TopMenu';
import Visualizer from '../Visualizer/Visualizer';

import styles from './VisualizerPage.module.css'
import ProductMenu from '../ProductMenu/ProductMenu';
import ShareModal from '../ShareModal/ShareModal';
import EmailShareModal from '../EmailShareModal/EmailShareModal';
import SampleCartModal from '../SampleCartModal/SampleCartModal';
import HelpModal from '../HelpModal/HelpModal';
import FeedbackModal from '../FeedbackModal/FeedbackModal';



export default function VisualizerPage() {
    const shareModalStatus = useSelector((state) => state.ui.shareModalActive);
    const emailModalStatus = useSelector((state) => state.ui.emailModalActive);
    const sampleCartModalStatus = useSelector((state) => state.ui.sampleCartModalActive);
    const helpModalStatus = useSelector((state) => state.ui.helpModalActive);
    const feedbackModalStatus = useSelector((state) => state.ui.feedbackModalActive);
    return (
        <>
            <TopMenu extended={true} page='visualizer'/>
            <section className={styles.visualizerView}>
            <div className={styles.visualizerContainer}>
                    <Visualizer />
                </div>
                <div className={styles.productMenuContainer}>
                    <ProductMenu />
                </div>
            </section>
            {shareModalStatus && <ShareModal/>}
            {emailModalStatus && <EmailShareModal />}
            {sampleCartModalStatus && <SampleCartModal />}
            {helpModalStatus && <HelpModal />}
            {feedbackModalStatus && <FeedbackModal />}
        </>
    );
    
}